import ROUTER from './ROUTER'

export const ACS_MENU_CONFIG = [
  {
    label: 'Ra vào & Vi phạm',
    key: 'subkey3',
    icon: 'BarChart3',
    tabid: ['ACS_VIOLATION_LIST', 'ACS_VIOLATION_STATS', 'ACS_CARD_SWIPE', 'ACS_CHECKIN_LOG'],
    children: [
      {
        key: ROUTER.DANH_SACH_VI_PHAM,
        label: 'Danh sách vi phạm',
        tabid: ['ACS_VIOLATION_LIST'],
      },
      {
        key: ROUTER.THONG_TIN_QUET_THE,
        label: 'Lịch sử ra vào',
        tabid: ['ACS_CARD_SWIPE'],
      },
      // {
      //   key: ROUTER.QUAN_LY_NHAN_VIEN_DIEM_DANH,
      //   label: 'Nhật ký điểm danh',
      //   tabid: ['ACS_CHECKIN_LOG'],
      // },
      // {
      //   label: "Phát hiện ra vào",
      //   key: ROUTER.PHAT_HIEN_RA_VAO,
      //   // icon: "CalendarRange"
      //   tabid: ["Detect_In_and_Out"],
      // },
      // {
      //   key: ROUTER.NGHI_PHEP_LIST,
      //   label: "Nghỉ phép",
      //   tabid: ["OnLeave"],
      // },
    ],
  },
  {
    label: 'Nhân viên',
    icon: 'UserSearch',
    key: 'subkey_acs_nhan_vien',
    tabid: [
      'ACS_GENERAL_INFO',
      'ACS_CARD_SWIPE',
      'ACS_LEAVE_INFO',
      'ACS_FINE_INFO',
      'ACS_COMPLAINT_LIST',
      'ACS_EVENT',
      'SYS_CHARGER_STATION',
      'DutySchedule',
      'ACS_TICKET_MGMT',
      'TicketManagement_User',
      'ACS_SHIFT_CHANGE',
    ],
    children: [
      // {
      //   key: ROUTER.THONG_TIN_CHUNG,
      //   label: 'Thông tin chung',
      //   tabid: ['ACS_GENERAL_INFO'],
      // },
      // {
      //   key: ROUTER.THONG_TIN_NGHI_PHEP,
      //   label: 'Thông tin nghỉ phép',
      //   tabid: ['ACS_LEAVE_INFO'],
      // },
      {
        key: ROUTER.THONG_TIN_TIEN_PHAT,
        label: 'Thông tin tiền phạt',
        tabid: ['ACS_FINE_INFO'],
      },
      {
        key: ROUTER.QUAN_LY_SU_KIEN,
        label: 'Sự kiện',
        tabid: ['ACS_Event'],
      },
      // {
      //   key: ROUTER.LICH_TRUC,
      //   label: 'Lịch trực',
      //   tabid: ['DutySchedule'],
      // },
      {
        key: ROUTER.QUAN_LY_PHIEU,
        label: 'Quản lý Phiếu',
        tabid: ['ACS_TICKET_MGMT', 'SYS_TICKET_USER'],
      },
      // {
      //   key: ROUTER.DANG_KY_DOI_CA,
      //   label: 'Quản lý đăng ký đổi ca',
      //   tabid: ['ShiftChangeRequestManagement'],
      // },
    ],
  },
  {
    label: 'Manager',
    key: 'subkey_acs_manager',
    icon: 'UserCog2',
    tabid: [
      'HRM_TIMEKEEPING',
      'ACS_EMP_MONITORING',
      'ACS_TRACKING_INFO',
      'ACS_SHIFT_INFO',
      'ACS_BUSINESS_TRIP_STATS',
      'ACS_LEAVE_STATS',
      'ACS_SHIFT_MGMT',
    ],
    children: [
      // {
      //   key: ROUTER.GIAM_SAT_NHAN_VIEN,
      //   label: 'Giám sát nhân viên',
      //   tabid: ['ACS_EMP_MONITORING'],
      // },
      // {
      //   key: ROUTER.THONG_TIN_THEO_DOI,
      //   label: 'Thông tin theo dõi',
      //   tabid: ['TrackingInformation'],
      // },
      // {
      //   key: ROUTER.THONG_TIN_CA_LAM_VIEC,
      //   label: 'Thông tin ca làm việc',
      //   tabid: ['ShiftInformation'],
      // },
      // {
      //   key: ROUTER.THONG_KE_CONG_TAC_PHI,
      //   label: 'Thống kê công tác phí',
      //   tabid: ['BusinessTripAllowanceStatistics'],
      // },
      {
        key: ROUTER.XU_LY_KHIEU_NAI,
        label: 'Xử lý khiếu nại',
        tabid: ['ACS_COMPLAINT_LIST'],
      },
      {
        key: ROUTER.THONG_KE_NGHI_PHEP,
        label: 'Thống kê nghỉ phép',
        tabid: ['ACS_LEAVE_STATS'],
      },
      {
        key: ROUTER.THONG_KE_VI_PHAM,
        label: 'Thống kê vi phạm',
        tabid: ['ACS_VIOLATION_STATS'],
      },
      // {
      //   key: ROUTER.QUAN_LY_CA_LAM_VIEC,
      //   label: 'Quản lý Ca làm việc',
      //   tabid: ['ShiftManagement'],
      // },
    ],
  },
]
// [
//   {
//     label: 'Attendance Checking System (ACS)',
//     key: 'subkey_acs',
//     icon: 'ShieldCheck',
//     tabid: ['ACS'],
//     type: 'group',
//     children:
//   },
// ]
export const HRM_MENU_CONFIG = [
  {
    key: ROUTER.CHAM_CONG,
    label: 'Chấm công (cc)',
    tabid: ['HRM_TIMEKEEPING'],
    icon: 'Clock3',
  },
  {
    key: ROUTER.THUONG_PHAT,
    label: 'Thưởng/Phạt',
    tabid: ['HRM_REWARD_PENALTY'],
    icon: 'BadgeDollarSign',
  },
  {
    key: ROUTER.VIEC_CAN_LAM_NGAY,
    label: 'Việc cần làm ngay',
    tabid: ['HRM_URGENT_TASKS'],
    icon: 'AlarmClockCheck',
  },
  {
    key: ROUTER.SO_YEU_LY_LICH,
    label: 'Sơ yếu lý lịch',
    tabid: ['HRM_CV'],
    icon: 'FileUser',
  },
  {
    key: ROUTER.SO_LIEU_LUONG,
    label: 'Số liệu lương',
    tabid: ['HRM_PAYROLL'],
    icon: 'Banknote',
  },
  {
    key: ROUTER.CHECKLIST_TEMPLATE,
    label: 'Mẫu Checklist',
    tabid: ['HRM_CHECKLIST'],
    icon: 'ClipboardCheck',
  },
  {
    key: ROUTER.CHECKLIST,
    label: 'Checklist',
    tabid: ['HRM_CHECKLIST'],
    icon: 'ClipboardCheck',
  },
  {
    key: ROUTER.TUYEN_DUNG,
    label: 'Tuyển dụng',
    tabid: ['HRM_RECRUITMENT'],
    icon: 'BriefcaseBusiness',
  },
  {
    key: ROUTER.TEST_ONLINE,
    label: 'Test Online',
    tabid: ['HRM_ONLINE_TEST'],
    icon: 'FileCheck2',
  },
  {
    key: ROUTER.QUAN_LY_DE_THI,
    label: 'Quản lý đề thi',
    tabid: ['HRM_EXAM_MGMT'],
    icon: 'FileCheck2',
  },
  {
    key: ROUTER.GIAM_TRU_GIA_CANH,
    label: 'Giảm trừ gia cảnh',
    tabid: ['HRM_DEPENDENT'],
    icon: 'Receipt',
  },
  {
    key: ROUTER.DANG_KY_LICH_HOC,
    label: 'Đăng ký lịch học',
    tabid: ['HRM_STUDENT_SCHEDULE'],
    icon: 'CalendarCheck2',
  },
  {
    key: ROUTER.QUAN_LY_LICH_HOC,
    label: 'Quản lý lịch học',
    tabid: ['HRM_CLASS_SCHEDULE'],
    icon: 'ClipboardCheck',
  },

  // {
  //   key: ROUTER.HR_DASHBOARD,
  //   label: 'Dashboard',
  //   tabid: ['DashBoard'],
  //   icon: 'LayoutDashboard',
  // },
]
//     [
//   {
//     label: 'Human Resource Management (HRM)',
//     key: 'subkey_hr',
//     icon: 'UserCheck',
//     tabid: ['HRM'],
//     type: 'group',
//     children: ,
//   },
// ]
export const ADMIN_MENU_CONFIG = [
  {
    key: ROUTER.THONG_KE_RA_VAO,
    label: 'Quản trị hệ thống',
    icon: 'Home',
    tabid: ['SYS_DASHBOARD'],
  },
  {
    key: 'subkey1',
    label: 'Xử lý yêu cầu',
    icon: 'RefreshCcw',
    tabid: ['SYS_APPROVE_ACCOUNT', 'SYS_APPROVE_CHANGE'],
    children: [
      // {
      //   key: ROUTER.DUYET_DON_NGHI,
      //   label: 'Duyệt phiếu',
      //   tabid: ['Approve_Ticket'],
      // },
      {
        key: ROUTER.DUYET_TAI_KHOAN_NHAN_VIEN,
        label: 'Duyệt tài khoản',
        tabid: ['SYS_APPROVE_ACCOUNT'],
      },
      {
        key: ROUTER.DUYET_THAY_DOI_THONG_TIN,
        label: 'Duyệt thay đổi thông tin',
        tabid: ['SYS_APPROVE_CHANGE'],
      },
    ],
  },

  {
    label: 'Cơ sở hạ tầng',
    key: 'subkey5',
    icon: 'Layers',
    tabid: ['SYS_DEVICE', 'SYS_CHARGER_STATION', 'SYS_DOOR', 'SYS_MEETING_LOCATION'],
    children: [
      {
        key: ROUTER.THONG_TIN_THIET_BI,
        label: 'Quản lý thiết bị',
        tabid: ['SYS_DEVICE'],
      },
      // {
      //   label: 'Trạm sạc',
      //   key: ROUTER.TRAM_SAC,
      //   tabid: ['Event'],
      // },
      {
        key: ROUTER.QUAN_LY_CUA,
        label: 'Quản lý cửa',
        tabid: ['SYS_DOOR'],
      },

      // {
      //   label: 'Quản lý địa điểm',
      //   key: ROUTER.QUAN_LY_PHONG_HOP,
      //   // icon: "DoorOpen"
      //   tabid: ['MeetingLocation'],
      // },
    ],
  },

  {
    label: 'Danh sách lịch họp',
    key: ROUTER.DANH_SACH_CUOC_HOP,
    icon: 'ScanEye',
    tabid: ['SYS_MEETING_LIST'],
  },
  {
    label: 'Quản lý tài khoản',
    key: 'subkey4',
    icon: 'Users',
    tabid: ['SYS_GUEST', 'SYS_DEPARTMENT'],
    children: [
      // {
      //   key: ROUTER.DANH_BA_NHAN_VIEN,
      //   label: 'Danh bạ nhân viên',
      //   tabid: ['Departments'],
      // },

      {
        label: 'Quản lý khách',
        key: ROUTER.DANH_SACH_KHACH,
        // icon: "UserCheck"
        tabid: ['SYS_GUEST'],
      },
      {
        label: 'Danh bạ nhân viên',
        key: ROUTER.DANH_BA_NHAN_VIEN,
        tabid: ['SYS_DEPARTMENT'],
      },
      // {
      //   key: ROUTER.NHAN_VIEN_DA_NGHI,
      //   label: 'Nhân viên đã nghỉ',
      //   tabid: ['StaffHasQuit'],
      // },
    ],
  },
  {
    label: 'Quản trị hệ thống',
    key: 'subkey6',
    icon: 'Settings',
    tabid: [
      'SYS_ROLE',
      'SYS_POSITION',
      'SYS_WORKING_CALENDAR',
      'SYS_DEPARTMENT',
      'SYS_FUNCTION_CATEGORY',
      'SYS_APPROVAL_WORKFLOW',
    ],
    children: [
      // {
      //   key: ROUTER.THONG_TIN_CA_LAM_VIEC,
      //   label: (
      //     <Space size={8} align="center">
      //       <span>Thông tin ca làm việc</span>
      //     </Space>
      //   ),
      //   tabid: [6],
      // },
      // {
      //   key: ROUTER.THONG_KE_NGHI_PHEP_SYSTEM,
      //   label: 'Thống kê nghỉ phép',
      //   tabid: [17],
      // },
      {
        key: ROUTER.QUAN_LY_PHAN_QUYEN,
        label: 'Phân quyền',
        tabid: ['SYS_ROLE'],
      },
      {
        key: ROUTER.CAI_DAT_TAI_KHOAN,
        label: 'Cài đặt tài khoản',
        tabid: ['SYS_ACCOUNT_SETTINGS'],
      },
      {
        key: ROUTER.QUAN_LY_DANH_MUC_CHUC_NANG,
        label: 'Danh mục chức năng',
        tabid: ['SYS_FUNCTION_CATEGORY'],
      },
      // {
      //   label: (
      //     <Space size={8} align="center">
      //       <span>Nhân viên vi phạm</span>
      //     </Space>
      //   ),
      //   tabid: [18],
      // },
      {
        key: ROUTER.DANH_SACH_CHUC_VU,
        label: 'Danh sách chức vụ',
        tabid: ['SYS_POSITION'],
      },
      {
        key: ROUTER.QUAN_LY_VI_TRI,
        label: 'Danh sách vị trí',
        tabid: ['SYS_JOB_POSITION'],
      },
      {
        key: ROUTER.LICH_NAM,
        label: 'Cấu hình ngày làm việc',
        // icon: "Calendar"
        tabid: ['SYS_WORKING_CALENDAR'],
      },
      {
        key: ROUTER.CAU_HINH_LUONG_DUYET,
        label: 'Cấu hình luồng duyệt',
        tabid: ['SYS_APPROVAL_WORKFLOW'],
      },
      // {
      //   key: ROUTER.CAU_HINH_NGHI_PHEP,
      //   label: (
      //     <Space size={8} align="center">
      //       <span>Cấu hình nghỉ phép</span>
      //     </Space>
      //   ),
      //   tabid: [19],
      // },
      // {
      //   key: ROUTER.QUAN_LY_PHAN_QUYEN,
      //   label: (
      //     <Space size={8} align="center">
      //       <span>Phân quyền</span>
      //     </Space>
      //   ),
      //   tabid: [7],
      // },

      // {
      //   key: ROUTER.LiCH_LAM_VIEC_LAM_BU,
      //   label: (
      //     <Space size={8} align="center">
      //       <span>Lịch làm việc làm bù</span>
      //     </Space>
      //   ),
      //   tabid: [17],
      // },
      // {
      //   key: ROUTER.GIAM_SAT_NHAN_VIEN,
      //   label: (
      //     <Space size={8} align="center">
      //       <span>Giám sát nhân viên</span>
      //     </Space>
      //   ),
      //   tabid: [17],
      // },
    ],
  },
  // {
  //   key: ROUTER.DUYET_THAY_DOI_THONG_TIN,
  //   label: "Duyệt thay đổi thông tin",
  //   icon: "SvgIcon" [10],
  // },

  // {
  //   label: "Quản lý khách mời",
  //   key: ROUTER.QUAN_LY_LICH_HOP,
  //   icon: "CalendarCheck2"
  //   tabid: [3],
  // },
  // {
  //   label: "Thông tin nghỉ phép",
  //   key: ROUTER.THONG_TIN_NGHI_PHEP,
  //   icon: "ClipboardMinus"
  //   tabid: [10],
  // },
  // {
  //   label: "Quản lý phiếu",
  //   key: ROUTER.QUAN_LY_PHIEU,
  //   icon: "Tickets"
  //   tabid: [17],
  // },

  // {
  //   label: "Tạo sự kiện",
  //   key: ROUTER.QUAN_LY_SU_KIEN,
  //   icon: "LandPlot"
  //   tabid: [17],
  // },
]

export const USER_MENU_CONFIG = [
  {
    label: 'Phân hệ thông tin cá nhân',
    key: 'subkey_user_profile',
    icon: 'CircleUser',
    // tabid: [
    //   'USER_OVERVIEW',
    //   'USER_PROFILE',
    //   'USER_WORKING_CALENDAR',
    //   'USER_MY_TICKETS',
    //   'USER_MY_VIOLATIONS',
    //   'USER_MY_CHECKIN',
    // ],
    children: [
      {
        key: ROUTER.TONG_QUAN_CUA_TOI,
        label: 'Tổng quan',
        // tabid: ['USER_OVERVIEW'],
      },
      {
        key: ROUTER.THONG_TIN_TAI_KHOAN,
        label: 'Thông tin cá nhân',
        // tabid: ['USER_PROFILE'],
      },
      {
        key: ROUTER.LICH_LAM_VIEC_CUA_TOI,
        label: 'Lịch làm việc',
        // tabid: ['USER_WORKING_CALENDAR'],
      },
      {
        key: ROUTER.CHI_TIET_NGHI_PHEP_CUA_TOI,
        label: 'Danh sách phiếu nghỉ phép',
        // tabid: ['USER_MY_TICKETS'],
      },
      {
        key: ROUTER.VI_PHAM_CUA_TOI,
        label: 'Danh sách vi phạm',
        // tabid: ['USER_MY_VIOLATIONS'],
      },
      {
        key: ROUTER.BANG_CONG,
        label: 'Lịch sử chấm công',
        // tabid: ['USER_MY_CHECKIN'],
      },
    ],
  },
]
